<template>
  <v-layout>
    <v-dialog v-model="isVisible" lazy persistent max-width="700px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="handleClose">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Close without saving</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-title class="mb-0 pb-0">
          <h5>
            <v-icon medium color="yellow">{{ modalIcon }}</v-icon>
            {{ modalTitle }}
          </h5>
          <blockquote>
            Create or go back to the previous page by clicking the "x" in the
            top left corner
          </blockquote>
        </v-card-title>
        <v-card-text>
          <business-lines-form-add
            ref="businessLineFormAdd"
            :loading="isLoading"
            @save="handleSave"
            :businessLine="item"
          ></business-lines-form-add>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import BusinessLinesFormAdd from "@/components/BusinessLinesFormAdd.vue";

export default {
  components: {
    BusinessLinesFormAdd
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        id: undefined,
        name: undefined,
        type: undefined,
        value: undefined,
        isOem: undefined,
        customizations: [],
        parents: []
      })
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEdit() {
      return this.item && this.item.name;
    },
    modalTitle() {
      return this.isEdit ? `Edit "${this.item.name}"` : "Create";
    },
    modalIcon() {
      return this.isEdit ? "edit" : "add";
    },
    modalDescription() {
      return this.isEdit
        ? `Edit ${
            this.item.name
          } or go back to the previous page by clicking the "x" in the top left corner`
        : `Create or go back to the previous page by clicking the "x" in the top left corner`;
    }
  },
  methods: {
    handleClose() {
      this.$emit("onClose");
    },
    handleSave(data) {
      this.$emit("onSave", data);
    }
  }
};
</script>
